<template>
  <div>
    <div class="pega-preview">
      <message-create-accordion-button v-if="uiVariation.showConfirmMessageArea">
        <h6 class="margin-0">
          ※メッセージを作成すると、キャリアデザインセンター サポート担当に送信されます。
        </h6>
        <message-input
          :value="value"
          :is-over-length="isOverLength"
          :max="maxMessageBody"
          @input="$emit('input', $event)"
        />
      </message-create-accordion-button>
      <div class="pega-examination-request-create-action-area">
        <div
          v-if="!isAllRequiredFilled"
          class="pega-notice pega-ml-15 text-center pega-examination-request-create-action-area-submit-notice-text"
          data-test="notice"
        >
          必須項目をすべて入力してください。
        </div>
        <div class="pega-examination-request-create-action-area-edit-button-area">
          <button
            class="boss-button boss-button-return"
            type="button"
            data-test="button-back"
            @click="onBackClick"
          >
            編集する
          </button>
        </div>
        <div class="pega-examination-request-create-action-area-submit-button-area">
          <button
            v-tooltip="uiVariation.showUnderReviewTooltip ? { content: '本求人は審査中です。'} : false"
            class="boss-button-center boss-button-confirm pega-button"
            type="button"
            data-test="button-submit"
            :disabled="isDisabledSubmit"
            @click="onSubmitClick"
          >
            申請する
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MessageCreateAccordionButton from '@/components/atoms/MessageCreateAccordionButton'
import MessageInput from '@/components/atoms/MessageInput'
import { getClientJobEditStatusUiVariation } from '@/lib/uiVariationMapping.js'

export default {
  components: {
    MessageCreateAccordionButton,
    MessageInput
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    isOverLength: {
      type: Boolean,
      default: false
    },
    isAllRequiredFilled: {
      type: Boolean,
      default: false
    },
    statusCode: {
      type: String,
      default: ''
    },
    maxMessageBody: {
      type: Number,
      default: 2000
    }
  },
  computed: {
    uiVariation () {
      return getClientJobEditStatusUiVariation(this.statusCode)
    },
    isDisabledSubmit () {
      return !this.isAllRequiredFilled || this.uiVariation.isDisabledRequestExaminationButton || this.isOverLength
    }
  },
  methods: {
    onBackClick () {
      this.$emit('back')
    },
    onSubmitClick () {
      this.$emit('submitted')
    }

  }
}
</script>
